// extracted by mini-css-extract-plugin
export default {"main":"AnimaBug_main__+wRe+","bug-moov":"AnimaBug_bug-moov__avYYY"};